import { render } from "./IntegratedDeviceHeading.vue?vue&type=template&id=2550c14a&scoped=true"
import script from "./IntegratedDeviceHeading.vue?vue&type=script&lang=js"
export * from "./IntegratedDeviceHeading.vue?vue&type=script&lang=js"

import "./IntegratedDeviceHeading.vue?vue&type=style&index=0&id=2550c14a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2550c14a"]])

export default __exports__